import React, { ReactNode } from 'react';

import classes from './CurrentPrice.module.scss';
import { getPriceView } from '../../../../shared/utils/stringUtils';
import {
  DiscountDescription,
  DiscountDescriptionProps,
} from '../DiscountDescription/DiscountDescription';

type CurrentPriceProps = {
  price: number | null | undefined;
  suffix?: ReactNode;
  hasDiscount?: boolean;
} & DiscountDescriptionProps;

const CurrentPrice = ({
  price,
  discountPercent,
  oldPrice,
  hasDiscount,
  suffix,
}: CurrentPriceProps) => {
  if (!price) {
    return null;
  }

  return (
    <p className={classes.box}>
      <span className={classes.currentPrice}>{getPriceView(price)}</span>
      {hasDiscount && (
        <DiscountDescription discountPercent={discountPercent} oldPrice={oldPrice} />
      )}
      {suffix && <span>{suffix}</span>}
    </p>
  );
};

export { CurrentPrice };
